export const GET_SIDEBAR_ACTIONS = "GET_SIDEBAR_ACTIONS";
export const SET_SIDEBAR_ACTIONS = "SET_SIDEBAR_ACTIONS";
export const SIDEBAR_EXPANDED_KEYS = "SIDEBAR_EXPANDED_KEYS";
